export default "__VITE_ASSET__CFoID2lX__"